import { useState } from 'react';
import { FaTimes } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase';


const LogIn = ({ showLogin, setShowLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();


    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/admin-dashboard');
            console.log("Logged In");
            setShowLogin(false);
            setEmail('');
            setPassword('');
        } catch (error) {
            alert('Invalid Credentials!')
            setShowLogin(false);
            setEmail('');
            setPassword('');
        }
    }

    return (
        showLogin && <section className="bg-[#03030380] z-30 fixed top-0 w-full h-full">
            <div className="bg-custom-gradient-1 dark:bg-custom-gradient-2 z-40 w-64 h-72 md:h-96 md:w-96 fixed inset-0 flex flex-col justify-center items-center m-auto shadow-lg rounded-lg">
                <div className='absolute top-2 right-2 cursor-pointer'><FaTimes className='dark:text-white' onClick={() => setShowLogin(false)} /> </div>
                <div className="mb-4 text-black dark:text-white">
                    <h1 className="md:text-2xl font-bold" >Log In</h1>
                </div>
                <form className="w-full px-4 md:px-8">
                    <div className="mb-4">
                        <label htmlFor="email" className="block text-white text-sm font-medium mb-2">
                            Email
                        </label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full p-1 md:p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            placeholder="Enter your email"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="password" className="block text-white text-sm font-medium mb-2">
                            Password
                        </label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full p-1 md:p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            placeholder="Enter your password"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium text-sm md:text-lg py-2 md:py-2 rounded"
                        onClick={handleLogin}
                    >
                        Log In
                    </button>

                    <p onClick={() => setShowLogin(false)} className="text-center text-xs dark:text-white mt-2 cursor-pointer">Login as guest?</p>
                </form>
            </div>
        </section>
    );
};

export default LogIn;
